import React from 'react';
import TerminosCondiciones from '../../TerminosCondiciones';
import './historial.css'
import useResizeEventIframe from '../../Utils/Iframe';
import headerCupra from '../../App/imgs/cupra/historial_guias.png';
import headerCupraMd from '../../App/imgs/cupra/historial_guias_md.png';
import headerCupraSm from '../../App/imgs/cupra/historial_guias_sm.png';
import './historial.scss'
import ButtonPrimary from '../../componentes/cupra/controls/ButtonPrimary';

class Historial extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            historial: [], aceptoTerminos: false, currentPage: 0, guias: [], perPage: 1
        };
        this.ref = React.createRef();
    }

    componentDidMount() {
        this.obtieneHistorial();
    }

    obtieneHistorial() {
        fetch(process.env.REACT_APP_URL_DTO_BACK + "historial", {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + this.props.servicio.getToken()
            }
        }).then(async res => {
            let responseBody = await res.json();
            if (res.status < 299) {
                this.setState({ historial: responseBody.mensaje })
                this.setState({ currentPage: 0 })
            } else {
                this.setState({ historial: [] });
            }
        }).catch(errorP => {
            console.log(errorP);
        });
    }

    handleClose = () => {
        if (this.props.marca === "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") !== true)
            window.location = "/app/sigue-tu-volkswagen/vw/inicio"
        else if (this.props.marca === "vw" && this.props.location.pathname.includes("/es/app/sigue-tu-volkswagen/vw/") === true)
            window.location = "/es/app/sigue-tu-volkswagen/vw/inicio.html"
        else
            window.location = "/" + this.props.marca + "/inicio";
    }

    setAceptoTerminos = (callback) => {
        this.setState({ aceptoTerminos: callback });
    }

    setCurrentPage = (current) => {
        this.setState({ currentPage: current })
    }

    render() {
        let SetResizeIframe = () => { useResizeEventIframe(this.ref); return null };
        return (
            <div ref={this.ref} className={this.props.marca === "cupra" ? "bg-cupra" : ""}>
                {this.props.marca === 'audi' && <SetResizeIframe />}
                {this.state.aceptoTerminos === false ?
                    <TerminosCondiciones marca={this.props.marca} servicio={this.props.servicio} servicioFirebase={this.props.servicioFirebase} callbackAceptoTerminos={this.setAceptoTerminos} mostrarMenu={this.props.marca !== 'vw'} mostrarFooter={this.props.marca !== 'vw'} />
                    :
                    <div >

                        <div className={"conteiner-header-cupra" + (this.props.marca === "cupra" ? "-visible" : "")}>
                            <img className='d-none d-lg-block consulta-img-header-cupra' src={headerCupra} alt="header_kmi_cupra" />
                            <img className='d-none d-md-block d-lg-none consulta-img-header-cupra' src={headerCupraMd} alt="header_kmi_cupra" />
                            <img className='d-block d-md-none consulta-img-header-cupra' src={headerCupraSm} alt="header_kmi_cupra" />
                        </div>
                        {
                            this.props.marca === "cupra" ?

                                (
                                    <div className="pb-5">

                                        <div className={"px-5 pt-md-5 pb-md-5 pt-0 pb-3 margin__top--titulo "}>
                                            <div className='d-flex justify-content-center'>
                                                <h2 className='title-historial'>Historial de guías</h2>
                                            </div>
                                            <p className="text-historial-guias mt-3 mt-md-5">Aquí puedes revisar tus guías de compra anteriores.</p>


                                        </div>
                                        <div className='fondo-blanco'>
                                            <div className={this.state.historial.length > 0 ? "d-none" : "p-2 p-lg-5"} >
                                                <p className="text-sincompra">Aún no has completado una compra.</p>
                                            </div>
                                            <div className={this.state.historial.length > 0 ? "p-2 p-lg-5" : "d-none"} >
                                                <p className="text-sincompra">Mis guías</p>
                                            </div>
                                            {
                                                this.props.marca !== "cupra" ?
                                                    this.state.historial.map((compra, i) => {
                                                        return <div key={i} > <div key={i} className="col">
                                                            <div className={"style_" + this.props.marca}>
                                                                <h4 id="lblModeloAuto">{compra.modeloInteres}</h4>
                                                                <h5 id="lblFechaentrega" className="fechaEntrega">{compra.fechaEntrega !== null ? "Entregado el " + compra.fechaEntrega : "Lo sentimos esta compra no fue completada."}</h5>
                                                                <h6 className="idEntrega">{compra.idCompra}</h6>
                                                            </div>
                                                        </div><br /></div>
                                                    }) : (<>

                                                        {
                                                            this.state.historial.map((compra, i) => {



                                                                return (
                                                                    <>

                                                                        {
                                                                            i >= this.state.currentPage && i < this.state.currentPage + this.state.perPage ? (
                                                                                <>
                                                                                    <div key={i} className='d-md-flex d-none justify-content-between card-guia-historial mb-4'>
                                                                                        <div>
                                                                                            <div className='label-historia-guia'>
                                                                                                Modelo:
                                                                                            </div>
                                                                                            <div className='modelo-text'>
                                                                                                {compra.modeloInteres}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div>
                                                                                            <div className='label-historia-guia'>
                                                                                                Entregado:
                                                                                            </div>
                                                                                            <div className='text-guia'>
                                                                                                {compra.fechaEntrega !== null ? compra.fechaEntrega : "Lo sentimos esta compra no fue completada."}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div>
                                                                                            <div className='label-historia-guia'>
                                                                                                Concesionaria:
                                                                                            </div>
                                                                                            <div className='text-guia'>
                                                                                                {compra.nombreConcesionario}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div key={i} className='d-block d-md-none justify-content-between card-guia-historial mb-4'>
                                                                                        <div className='my-2'>
                                                                                            <div className='label-historia-guia'>
                                                                                                Modelo:
                                                                                            </div>
                                                                                            <div className='modelo-text'>
                                                                                                {compra.modeloInteres}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='my-2'>
                                                                                            <div className='label-historia-guia'>
                                                                                                Entregado:
                                                                                            </div>
                                                                                            <div className='text-guia'>
                                                                                                {compra.fechaEntrega !== null ? compra.fechaEntrega : "Lo sentimos esta compra no fue completada."}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='my-2'>
                                                                                            <div className='label-historia-guia'>
                                                                                                Concesionaria:
                                                                                            </div>
                                                                                            <div className='text-guia'>
                                                                                                {compra.nombreConcesionario}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </>

                                                                            ) : (<></>)
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </>)
                                            }

                                            <div className="d-flex justify-content-center my-5 pb-5 px-4 px-lg-0">
                                                <ButtonPrimary style={{ marginTop: '30px' }} onClick={this.handleClose} textButton={"Regresar a SIGUE TU CUPRA"} />
                                            </div>
                                        </div>
                                    </div>
                                )

                                :

                                (
                                    <div className="container">

                                        <div className={"col col-md-8 offset-md-2 pt-5 pb-5 margin__top--titulo"}>
                                            <div>
                                                <h2>Historial de guías</h2>
                                            </div>
                                            <p className={this.props.marca}>Aquí puedes revisar tus guías de compra anteriores.</p>

                                            <div className="div_scroll audiScroll" >
                                                <div className={this.state.historial.length > 0 ? "d-none" : ""} >
                                                    <p className={this.props.marca}>Aún no has completado una compra.</p>
                                                </div>
                                                {
                                                    this.state.historial.map((compra, i) => {
                                                        return <div key={i} > <div key={i} className="col">
                                                            <div className={"style_" + this.props.marca}>
                                                                <h4 id="lblModeloAuto">{compra.modeloInteres}</h4>
                                                                <h5 id="lblFechaentrega" className="fechaEntrega">{compra.fechaEntrega !== null ? "Entregado el " + compra.fechaEntrega : "Lo sentimos esta compra no fue completada."}</h5>
                                                                <h6 className="idEntrega">{compra.idCompra}</h6>
                                                            </div>
                                                        </div><br /></div>
                                                    })
                                                }
                                            </div>
                                            <br></br>
                                            <br></br>
                                            <div className="col-xs-12 mt-3">
                                                <div className="button">
                                                    <button className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca} name="consultar" onClick={this.handleClose}>Regresar</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                        }
                    </div>
                }
            </div>
        )
    }
}
export default Historial;